var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65079 7.75926C8.2763 8.08025 7.7237 8.08025 7.34921 7.75926L0.349227 1.75927C-0.0700983 1.39985 -0.118659 0.768551 0.240761 0.349226C0.600183 -0.0700983 1.23148 -0.11866 1.65081 0.240761L8 5.68293L14.3492 0.240762C14.7685 -0.118659 15.3998 -0.070097 15.7592 0.349227C16.1187 0.768552 16.0701 1.39985 15.6508 1.75927L8.65079 7.75926Z",
    fill: "#181C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownChevron);
export default __webpack_public_path__ + "static/media/down_chevron.e311bcab89197e4d6cd8bf215b3bb314.svg";
export { ForwardRef as ReactComponent };